// src/Pages/FAQ.js
import React from "react";
import { Link } from "react-router-dom";
import "./FAQ_pages/FAQ.css";

export default function FAQ() {
  return (
    <div className="faq-page">
      <h2 className="faq-title">Instructions & FAQ</h2>

      {/* Quick Links */}
      <div className="steps-grid" aria-label="Instruction Links">
        <Link to="/faq/events" className="step-card">
          <h3>Gathering Host Instructions</h3>
          <span className="step-sub">Create & run your event</span>
        </Link>
        <Link to="/faq/vendors" className="step-card">
          <h3>Vendor Instructions</h3>
          <span className="step-sub">Create a vendor profile</span>
        </Link>
        <Link to="/faq/artists" className="step-card">
          <h3>Artist Instructions</h3>
          <span className="step-sub">Create an artist profile</span>
        </Link>
        <Link to="/faq/referral" className="step-card">
          <h3>Referral Instructions</h3>
          <span className="step-sub">Earn rewards</span>
        </Link>
      </div>

      {/* General Questions */}
      <section className="faq-section">
        <h3 className="faq-heading-inline">General Questions</h3>

        <div className="faq-table" role="table" aria-label="Frequently Asked Questions">
          <div className="faq-row faq-header" role="row">
            <div className="faq-cell faq-qhead" role="columnheader">Question</div>
            <div className="faq-cell faq-ahead" role="columnheader">Answer</div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              What is <strong>itiniri</strong>?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              <strong>itiniri</strong> is an Event Management Platform and mobile application
              that provides a clean and easy-to-use interface for events of all kinds. Our
              website allows Event Managers, Vendors and Artists to enter their event
              information, and the app displays that information to attendees in a virtual program.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How do I create and publish my event?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              See the <Link to="/faq/events">Gathering Host Instructions</Link> section.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How do I add and manage vendors?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              Refer to <Link to="/faq/vendors">Vendor Instructions</Link>.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How do I create an artist profile?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              See <Link to="/faq/artists">Artist Instructions</Link>.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How do I create a vendor profile?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              See <Link to="/faq/vendors">Vendor Instructions</Link>.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How do I add Vendors and Artists to my event?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              In the <strong>Vendors</strong> or <strong>Artists</strong> tab of your Event
              Dashboard, you will see your unique Gathering Reference ID. Share that with your
              Vendors and Artists, and they can use it to add themselves to your event with their
              own customized profiles. As Event Host, you don't have to enter any information for
              Artists or Vendors.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How do I remove Vendors or Artists from my event?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              You can remove a Vendor or Artist inside the <strong>Vendors</strong> or{" "}
              <strong>Artists</strong> tabs, respectively.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How do I remove an Artist from an event in the schedule?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              Once linked to your Gathering, an Artist can “claim” an event to link their profile.
              If multiple artists are linked to a single event, customize the order in the
              Schedule tab by clicking the Event. To remove an Artist, click the <strong>x</strong>{" "}
              next to their name.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              Is there a limit to the number of Events I can create?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              There is currently a limit of three Events per user until one Event is paid for.
              After submitting payment for one Event, you can create as many Events as you want.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              Can other members of my team also log in and make changes?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              Yes. If you've created the Event, you are the Event Host. You can add Team Members
              via their email in the <strong>Team</strong> tab of your Event Dashboard. They can
              then make changes and publish announcements.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How does the referral program work?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              Details are in <Link to="/faq/referral">Referral Instructions</Link>.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              Can I update my event details after publishing?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              Yes—changes made on the website are automatically displayed in the app. No need to
              re-publish.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How do I reset my password?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              Enter your account email on{" "}
              <Link to="http://itiniri.app/auth">our login page</Link> and click{" "}
              <strong>Forgot password</strong>.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              Is there a limit on vendors or artists?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              No—add as many as needed.
            </div>
          </div>

          <div className="faq-row" role="row">
            <div className="faq-cell faq-q" role="cell" data-label="Question">
              How do I contact support?
            </div>
            <div className="faq-cell faq-a" role="cell" data-label="Answer">
              Submit a ticket or chat via our <Link to="/support">Support</Link> page.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
